var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-bar"},[_c('el-button',{staticClass:"uploadbtn",attrs:{"size":"mini","type":"primary"},on:{"click":_vm.renewlist}},[_vm._v(" 刷新 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }